document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[id^="tg-buybox-"]').forEach(function(wrap){
    var variantsEl = wrap.querySelector('.tg-variants-data');
    if (!variantsEl) return;
    var variants = JSON.parse(variantsEl.textContent);
    var currencySymbol = wrap.getAttribute('data-currency') || '$';

    var bundleVariantsEl = wrap.querySelector('.tg-bundle-variants-data');
    var bundleVariants = bundleVariantsEl ? JSON.parse(bundleVariantsEl.textContent) : [];

    var mediaEl = wrap.querySelector('.tg-media-data');
    var mediaList = mediaEl ? JSON.parse(mediaEl.textContent) : [];
    var mediaIndex = 0;

    function goToImage(i){
      if (!mediaList.length) return;
      mediaIndex = (i + mediaList.length) % mediaList.length;
      var mainImg = wrap.querySelector('.tg-main-img');
      if (mainImg) mainImg.src = mediaList[mediaIndex];
      wrap.querySelectorAll('[data-dots] .tg-dot').forEach(function(d, idx){
        d.classList.toggle('tg-dot-active', idx === mediaIndex);
      });
    }

    var prevBtn = wrap.querySelector('[data-nav-prev]');
    var nextBtn = wrap.querySelector('[data-nav-next]');
    if (prevBtn) prevBtn.addEventListener('click', function(){ goToImage(mediaIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ goToImage(mediaIndex + 1); });
    wrap.querySelectorAll('[data-dots] .tg-dot').forEach(function(dot){
      dot.addEventListener('click', function(){ goToImage(parseInt(dot.getAttribute('data-dot-index'), 10)); });
    });

    var state = { size: null, color: null };
    var activeSize = wrap.querySelector('[data-pills] .tg-pill-active');
    if (activeSize) state.size = activeSize.getAttribute('data-size');
    var activeColor = wrap.querySelector('[data-swatches] .tg-swatch-active');
    if (activeColor) state.color = activeColor.getAttribute('data-color');

    function findVariant(){
      return variants.find(function(v){
        var sizeMatch = !state.size || v.o1 === state.size || v.o2 === state.size;
        var colorMatch = !state.color || v.o1 === state.color || v.o2 === state.color;
        return sizeMatch && colorMatch;
      }) || variants[0];
    }

    function findBundleVariant(){
      if (!bundleVariants.length) return null;
      return bundleVariants.find(function(v){
        var sizeMatch = !state.size || v.o1 === state.size || v.o2 === state.size;
        var colorMatch = !state.color || v.o1 === state.color || v.o2 === state.color;
        return sizeMatch && colorMatch;
      }) || bundleVariants[0];
    }

    function fmt(cents){ return currencySymbol + (cents/100).toFixed(2); }

    function renderStock(v){
      var el = wrap.querySelector('[data-stock-note]');
      if (!el) return;
      if (!v.available) { el.innerHTML = ''; return; }
      var q = v.qty;
      if (q > 0 && q <= 10) {
        el.innerHTML = '<div class="tg-stock-note tg-stock-low"><span class="tg-stock-dot"></span>Only ' + q + ' left in stock — order soon</div>';
      } else if (q > 10) {
        el.innerHTML = '<div class="tg-stock-note tg-stock-ok"><span class="tg-stock-dot"></span>In stock, ready to ship</div>';
      } else {
        el.innerHTML = '';
      }
    }

    function getChoice(){
      var row = wrap.querySelector('[data-bundle-box] .tg-bundle-row-active');
      return row ? row.getAttribute('data-choice') : 'bundle';
    }

    function renderBundle(){
      var hv = findVariant();
      var bv = findBundleVariant();

      var nowBundle = wrap.querySelector('[data-now="bundle"]');
      var wasBundle = wrap.querySelector('[data-was="bundle"]');
      if (bv) {
        if (nowBundle) nowBundle.textContent = fmt(bv.price);
        if (wasBundle) wasBundle.textContent = bv.compareAtPrice > bv.price ? fmt(bv.compareAtPrice) : '';
      } else {
        if (nowBundle) nowBundle.textContent = '';
        if (wasBundle) wasBundle.textContent = '';
      }

      var nowHarness = wrap.querySelector('[data-now="harness"]');
      var wasHarness = wrap.querySelector('[data-was="harness"]');
      if (nowHarness) nowHarness.textContent = fmt(hv.price);
      if (wasHarness) wasHarness.textContent = hv.compareAtPrice > hv.price ? fmt(hv.compareAtPrice) : '';

      var choice = getChoice();
      var active = (choice === 'bundle' && bv) ? bv : hv;

      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = fmt(active.price);
      var stickyImg = document.querySelector('[data-sticky-img]');
      if (stickyImg) { stickyImg.src = active.image || hv.imageSmall || ''; }

      var variantInput = wrap.querySelector('[data-variant-input]');
      if (variantInput) variantInput.value = active.id;
      var qtyInput = wrap.querySelector('[data-quantity-input]');
      if (qtyInput) qtyInput.value = 1;

      var atc = wrap.querySelector('[data-atc-btn]');
      if (atc) {
        atc.disabled = !active.available;
        atc.textContent = active.available ? atc.getAttribute('data-label') : 'Sold Out';
      }
      var stickyBtn = document.querySelector('[data-sticky-btn]');
      if (stickyBtn) { stickyBtn.disabled = !active.available; }

      var mainImg = wrap.querySelector('.tg-main-img');
      if (active.image && mainImg) { mainImg.src = active.image; }

      renderStock(active);
    }

    wrap.querySelectorAll('[data-pills] .tg-pill').forEach(function(btn){
      btn.addEventListener('click', function(){
        wrap.querySelectorAll('[data-pills] .tg-pill').forEach(function(p){ p.classList.remove('tg-pill-active'); });
        btn.classList.add('tg-pill-active');
        state.size = btn.getAttribute('data-size');
        renderBundle();
      });
    });

    wrap.querySelectorAll('[data-swatches] .tg-swatch').forEach(function(btn){
      btn.addEventListener('click', function(){
        wrap.querySelectorAll('[data-swatches] .tg-swatch').forEach(function(s){ s.classList.remove('tg-swatch-active'); });
        btn.classList.add('tg-swatch-active');
        state.color = btn.getAttribute('data-color');
        var lbl = wrap.querySelector('[data-color-label]');
        if (lbl) lbl.textContent = btn.getAttribute('data-color');
        renderBundle();
      });
    });

    wrap.querySelectorAll('[data-bundle-box] .tg-bundle-row').forEach(function(row) {
      row.addEventListener('click', function() {
        wrap.querySelectorAll('[data-bundle-box] .tg-bundle-row').forEach(function(r) {
          r.classList.remove('tg-bundle-row-active');
          var radio = r.querySelector('.tg-bundle-radio');
          if (radio) radio.classList.remove('tg-bundle-radio-active');
        });
        row.classList.add('tg-bundle-row-active');
        var radio = row.querySelector('.tg-bundle-radio');
        if (radio) radio.classList.add('tg-bundle-radio-active');
        renderBundle();
      });
    });

    var stickyBtnEl = document.querySelector('[data-sticky-btn]');
    if (stickyBtnEl) {
      stickyBtnEl.addEventListener('click', function(){
        var form = wrap.querySelector('[data-buybox-form]');
        if (form) form.requestSubmit();
      });
    }

    renderBundle();

    var mainAtc = wrap.querySelector('[data-atc-btn]');
    var stickyBar = document.querySelector('[data-sticky-bar]');
    var stickyDismissed = false;

    var stickyCloseBtn = document.querySelector('[data-sticky-close]');
    if (stickyCloseBtn && stickyBar) {
      stickyCloseBtn.addEventListener('click', function(){
        stickyDismissed = true;
        stickyBar.classList.remove('tg-sticky-visible');
      });
    }

    var stickyTopBtn = document.querySelector('[data-sticky-top]');
    if (stickyTopBtn) {
      stickyTopBtn.addEventListener('click', function(){
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    if (mainAtc && stickyBar && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        if (stickyDismissed) return;
        entries.forEach(function(entry){
          if (entry.isIntersecting) {
            stickyBar.classList.remove('tg-sticky-visible');
          } else if (entry.boundingClientRect.top < 0) {
            stickyBar.classList.add('tg-sticky-visible');
          } else {
            stickyBar.classList.remove('tg-sticky-visible');
          }
        });
      }, { threshold: 0 });
      io.observe(mainAtc);
    }

    var cdWrap = wrap.querySelector('[data-countdown]');
    if (cdWrap) {
      var hEl = cdWrap.querySelector('[data-cd-h]');
      var mEl = cdWrap.querySelector('[data-cd-m]');
      var sEl = cdWrap.querySelector('[data-cd-s]');
      function pad(n){ return n < 10 ? '0' + n : '' + n; }
      function tick(){
        var now = new Date();
        var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
        var diff = Math.max(0, midnight - now);
        var totalSeconds = Math.floor(diff / 1000);
        var h = Math.floor(totalSeconds / 3600);
        var m = Math.floor((totalSeconds % 3600) / 60);
        var s = totalSeconds % 60;
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      }
      tick();
      setInterval(tick, 1000);
    }
  });
});
